import React from 'react'
import { useTranslation } from 'react-i18next'

import { ACHFormValues } from 'adminDashboard/companySettings/subscription/paymentInformation/ach/AchForm'
import { Tabs } from 'antd'

import {
  ACHDetails,
  CreditCardDetails,
  PaymentMethod,
  Subscription,
} from 'core/application/adminDashboard/companySettings/subscription/subscriptionDetails'

import TabPane from 'common/components/dataDisplay/TabPane'

import ACHLogoActive from 'assets/images/ACHLogoActive'
import ACHLogoInactive from 'assets/images/ACHLogoInactive'
import CreditCardLogoActive from 'assets/images/CreditCardLogoActive'
import CreditCardLogoInactive from 'assets/images/CreditCardLogoInactive'

import RenewalAchForm from './RenewalACHForm'
import RenewalCreditCardForm from './RenewalCreditCardForm'

interface EditPaymentInformationProps {
  paymentMethod: string
  achFormValues: ACHFormValues
  recurlyErrors: Map<string, string>
  paymentDetails: ACHDetails | CreditCardDetails
  setPaymentMethod: (value: string) => void
  submitACH: (value: ACHFormValues) => void
}

const EditPaymentInformation: React.FC<EditPaymentInformationProps> = ({
  paymentMethod,
  achFormValues,
  recurlyErrors,
  paymentDetails,
  setPaymentMethod,
  submitACH,
}) => {
  const { t: translate } = useTranslation()
  const handleChange = (key: string) => setPaymentMethod(key)
  return (
    <Tabs onChange={handleChange} activeKey={paymentMethod}>
      <TabPane
        tab={
          <p>
            {paymentMethod === PaymentMethod.ACH.toString() ? <ACHLogoActive /> : <ACHLogoInactive />}
            {translate('admin-signup.subscription.payment.ach-label')}
          </p>
        }
        key={PaymentMethod.ACH.toString()}
      >
        <RenewalAchForm recurlyErrors={recurlyErrors} achFormValues={achFormValues} submitACH={submitACH} />
      </TabPane>
      <TabPane
        tab={
          <p>
            {paymentMethod === PaymentMethod.CreditCard.toString() ? (
              <CreditCardLogoActive />
            ) : (
              <CreditCardLogoInactive />
            )}
            {translate('admin-signup.subscription.payment.credit-card-label')}
          </p>
        }
        key={PaymentMethod.CreditCard.toString()}
      >
        <RenewalCreditCardForm paymentDetails={paymentDetails as CreditCardDetails} recurlyErrors={recurlyErrors} />
      </TabPane>
    </Tabs>
  )
}

export default EditPaymentInformation
